import {
  StyleSheet,
  ImageBackground,
  SafeAreaView,
  useWindowDimensions,
} from "react-native";
import React from "react";
import {
  View,
  ScrollView,
  Text,
  Heading,
  Box,
  VStack,
  HStack,
  Pressable,
} from "native-base";
import { StackScreenProps } from "../../types";
import Card, { CardProps } from "../../components/Card";
import { LinearGradient } from "expo-linear-gradient";
import Header from "../../components/Header";
import CountUp from "react-countup";

const Media = ({ navigation }: StackScreenProps<"Media">) => {
  const { width, height } = useWindowDimensions();
  const fftv = require("../../assets/fortune_tv.png");
  const ffr = require("../../assets/fortune_radio.png");
  interface D extends CardProps {
    bgc: string;
  }

  const data: D[] = [
    {
      heading: "Farm & Fortune TV Show",
      subheading: "",
      details: "",
      iconName: "",
      onPress: () => navigation.navigate("FFtv"),
      image: fftv,
      bgc: "#007C6B",
    },
    {
      heading: "Farm & Fortune Radio Show",
      subheading: "",
      details: "",
      iconName: "",
      onPress: () => navigation.navigate("FFradio"),
      image: ffr,
      bgc: "rgba(158, 40, 66, 1)",
    },
  ];

  return (
    <ImageBackground
      source={require("../../assets/media_bgd.png")}
      resizeMode="cover"
      style={{ width, height }}
    >
      <View style={styles.overlay}>
        <SafeAreaView style={{ height }}>
          <ScrollView>
            <Header
              onPress={() => navigation.navigate("FarmerCentricProjects")}
              parentText="Farmer-Centric Projects"
              headingText="Media"
            />

            <Text textAlign="center" px={5} mb="3">
              Farm and Fortune Media was conceived in the wake of the Covid-19
              pandemic to support smallholder famers in Nigeria due to OCP
              Africa’s inability to reach out to smallholder farmers as a result
              the COVID-19 restrictions. The Program leverages real stories and
              scenarios from the farm to enlighten its audience through a panel
              of experts.
            </Text>

            <Text textAlign="center" px={5} mb="3">
              Supporting Smallholder Farmers amid COVID-19 was a challenge due
              to restrictive measures and media platforms became the best
              alternative to reach farmers hence, The Farm & Fortune project was
              birthed.
            </Text>

            <Text textAlign="center" px={5} mb="3">
              The Farm & Fortune project was designed as a communications
              channel to inform, educate, and sensitise the Nigerian audience on
              the importance and opportunities in Agriculture, but more
              importantly the efficacy, profitability, and benefits of Good
              Agricultural Practice (GAP).
            </Text>

            <Text textAlign="center" px={5} mb={25}>
              Built on the bedrock of opportunities that technology has to
              offer, the project employed the use of Radio and Television
              communication as part of the means of communication taking
              advantage of its wide audience reach of over 100 million Nigerians
              to share and communicate the idea.
            </Text>

            {data.map((item) => (
              <Pressable key={item.heading} mb={10} onPress={item.onPress}>
                <Card
                  heading={item.heading}
                  subheading={item.subheading}
                  details={item.details}
                  iconName={item.iconName}
                  onPress={item.onPress}
                  borderBottomColor="#333333ac"
                  borderColor="#aaa"
                  bg={item?.bgc}
                  // image={item.image}
                />
              </Pressable>
            ))}

            <View mt={10}></View>
          </ScrollView>
        </SafeAreaView>
      </View>
    </ImageBackground>
  );
};

export default Media;

const styles = StyleSheet.create({
  overlay: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: "#221919b8",
  },
  cardOverlay: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: "rgba(0, 0, 0, 0.2)",
  },
});
